export const CREATE_NACELLE = "CREATE_NACELLE";
export const RETRIEVE_NACELLES = "RETRIEVE_NACELLES";
export const UPDATE_NACELLE = "UPDATE_NACELLE";
export const DELETE_NACELLE = "DELETE_NACELLE";
export const DELETE_ALL_NACELLES = "DELETE_ALL_NACELLES";